import { Component, OnInit, Inject } from '@angular/core';
import {environment} from '../../environments/environment';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { HttpService } from '../services/HttpService';
import { NotificationService } from '../services/NotificationService';
import { FileUploadService } from '../services/FileUploadService';

@Component({
  selector: 'app-select-brand',
  templateUrl: './select-brand.component.html',
  styleUrls: ['./select-brand.component.css'],
  providers: [HttpService, NotificationService, FileUploadService]
})
export class SelectBrandComponent implements OnInit {

  public apiUrl = environment.apiUrl;

    public loading: boolean = false;
	public User_Details: any;

    public brand;
    public allBrands;
    public selectedBrand;
    public filteredBrands;

    constructor(
        public dialogRef: MatDialogRef<SelectBrandComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
        public http: HttpService,
		public notification: NotificationService,
		public fileUpload: FileUploadService
    ) { }

    ngOnInit() {
        this.User_Details = JSON.parse(localStorage.getItem("Admin_User_Details"));
		this.brand = this.data.brandDetails;
        this.allBrands = this.data.allBrands;
        this.filteredBrands = this.allBrands;
    }

    setSelectedBrand(brand, option){
        for (var i = 0; i < this.allBrands.length; i++) {
            if (this.allBrands[i].id == option) {
                brand.selected_brand = this.allBrands[i];
                this.selectedBrand = this.allBrands[i];
            }
        }
    }

    updateParent() {
        this.loading = true;

        this.http.makeRequestPost(['app/user/brands/set_brand_parent_brand',
                {
                    id: this.brand.id,
                    parent_id: this.selectedBrand.id
                }
            ]
        )
        .subscribe(
            (resp) => {
                this.loading = false;
                if (resp.data) {
                    this.notification.showNotification('The brand has been assigned a parent brand', 'Success', 'success');
                    this.dialogRef.close(); // perhaps pass everything back here
                } else {
                    this.notification.showNotification('Could not assign the parent brand', 'Error', 'error');
                }
            },
            (error) => {
                this.loading = false;
                this.notification.showNotification('Please make sure you have a working data connection', 'Error', 'error');
            }
        )
    }

    checkShowBrand(brand, option) {
        if (brand.id == option.id) {
            return false;
        }

        if (option.parent_id != null) {
            return false;
        }

        return true;
    }

    onKey(value) { 
        this.filteredBrands = this.search(value);
    }

    search( value: string){
        let filter = value.toLowerCase();
        return this.allBrands.filter( x => {
            if (x.name.toLowerCase().startsWith(filter)){
                return x
            }
            
        } )
    }

    setFocus(el){
        el.focus();
    }

}



// WEBPACK FOOTER //
// ./src/app/select-brand/select-brand.component.ts